import React from "react";
import { View, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";

interface AmountProps {
  processing: any;
  processed: any;
  deliveredCustomer: any;
}

const AmountTag: React.FC<AmountProps> = ({
  processing,
  processed,
  deliveredCustomer,
}) => {
  return (
    <View style={styles.container}>
      <View style={styles.itemContainer}>
        <Text variant="caption_2" style={styles.label}>
          {processing?.title} :
        </Text>
        <Text variant="caption_1" style={styles.amount}>
          {processing?.value}
        </Text>
      </View>
      <View style={styles.divider} />
      <View style={styles.itemContainer}>
        <Text variant="caption_2" style={styles.label}>
          {processed?.title} :
        </Text>
        <Text variant="caption_1" style={styles.amount}>
          {processed?.value}
        </Text>
      </View>
      <View style={styles.divider} />
      <View style={styles.itemContainer}>
        <Text variant="caption_2" style={styles.label}>
          {deliveredCustomer?.title} :
        </Text>
        <Text variant="caption_1" style={styles.amount}>
          {deliveredCustomer?.value}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: color.white,
    paddingVertical: 4,
    paddingTop: 6,
    paddingHorizontal: 8,
    borderRadius: 4,
    maxWidth: "100%",
    justifyContent: "space-evenly",
    marginHorizontal: 16,
    elevation: 1,
    marginTop: 4,
  },
  itemContainer: {
    flexDirection: "row",
    alignItems: "center",
    overflow: "hidden",
    maxWidth: "50%",
  },
  label: {
    marginRight: 2,
  },
  amount: {
    lineHeight: 16,
  },
  divider: {
    width: 1,
    height: "100%",
    backgroundColor: "#e0e0e0",
  },
});

export default AmountTag;
